<div class="vehicle-container">
	<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css">
	<div class="buttonstart" (click)="onButtonGroupClick($event)">
		<button type="button" class="btn btn-primary mr-3 shadow-none" (click)="openModal()">START DIAGNOSIS</button>
		<button routerLink="/vehiclesession" type="button" class="btn btn-primary mr-3 shadow-none">RESUME
			SESSION</button>
	</div>
	<div style="float: left;width: 50%;">
		<div class="sections">
			<div class="box"><i class="fa fa-bell fa-lg" aria-hidden="true"></i>
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow=!isShow" *ngIf="!isShow" title="Click to expand"></i>
					<i *ngIf="isShow" class="fa fa-minus-square" (click)="isShow=!isShow" title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Outstanding Field Service Actions</h2>
					<span>No Campaign Message(s) found</span>
					<div *ngIf="isShow">
						<span>
							We will check for outstanding service actions on your selected vehicle,
							using your detected country, if this is incorrect you may not see the right information.
							<br>We have detected that you are in the: United Kingdom<br>If this information is
							incorrect,
							click <a href="#" onclick="showLanguagePreference(); return false;">here</a> to change your
							country.</span>
					</div>
				</div>
			</div>
			<div class="box1">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow1=!isShow1" *ngIf="!isShow1"
						title="Click to expand"></i>
					<i *ngIf="isShow1" class="fa fa-minus-square" (click)="isShow1=!isShow1"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Mechanical Repairs</h2>
					<p><span>
							<a href="#">Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br>
						</span></p>
					<h2>Wiring Diagrams</h2>
					<p><span>
							<a href="#">Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br>
						</span></p>
					<div *ngIf="isShow1">
						<h2>Body &amp; Paint</h2>
						<p><span>
								<a href="#">Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br>
							</span></p>
						<h2>Guided Diagnostics</h2>
						<p><span>
								<a href="#">Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br>
							</span></p>
					</div>
				</div>
			</div>
			<div class="box3">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow3=!isShow3" *ngIf="!isShow3"
						title="Click to expand"></i>
					<i *ngIf="isShow3" class="fa fa-minus-square" (click)="isShow3=!isShow3"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Vehicle Software</h2>
					<span>Vehicle software information is available for your selected vehicle.
						Click <a href="#">here</a> to view further information.</span>
					<div style="display: block;" *ngIf="isShow3">
					</div>
				</div>
			</div>
			<div class="box4">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow4=!isShow4" *ngIf="!isShow4"
						title="Click to expand"></i>
					<i *ngIf="isShow4" class="fa fa-minus-square" (click)="isShow4=!isShow4"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Training</h2>
					<p><span>New Product Introduction -<a href="#">
								Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br></span>
						<span>e-Product Introduction -<a href="#">
								Transit Connect/Tourneo Connect 2014.00 (02/2013-)</a><br></span>
					</p>
					<div style="display: block;" *ngIf="isShow4">
						<h2>Vehicle Conversions</h2>
						<p><span><a href="#">Body &amp; Equipment Mounting Manual (BEMM)</a></span></p>
						<h2>Diagnostic Trouble Code (DTC)</h2>
						<p><span><a href="#">Diagnostic Trouble Code Search</a></span></p>
						<h2>Type Approval Number</h2>
						<p><span>Type Approval Number (TAN):&nbsp;<a href="#">Click Here</a></span></p>
						<h2>Parts Catalog</h2>
						<p><span><a href="#">www.fordecat.com</a></span></p>
						<h2>Rescue Cards</h2>
						<p><span><a href="#">Download Rescue Cards</a></span></p>
					</div>
				</div>
			</div>
			<div class="box5">
				<div class="panel-body">
					<h2>FordService</h2>
					<p><span><a href="#">Generate a FordService schedule</a></span></p>
				</div>
			</div>
		</div>
	</div>
	<div style="float: left;width: 50%;">
		<div class="sections">
			<div class="box6">
				<div style="padding: 8px;font-size: 12px;margin-left: 30px;">
					<div>
						<h2><span style="color: #003f87;">You may select a vehicle by using the following
								methods:</span></h2>
					</div>
					<div class="input-group " style="height: 25px">
						<input type="text" maxlength="17" class="lookup-input ng-untouched ng-pristine ng-valid"
							ng-reflect-maxlength="17" placeholder="Enter VIN" ng-reflect-model=""
							style="font-size:14px; width: 40%;border: 1px solid #003478;" [(ngModel)]="invinnumber"
							name="invinnumber" id="invinnumber">
						<span>
							<button type="button" class="lookup-btn" style="width: 100%;
							height: 100%;background-color: #003478;border-top-right-radius: 5px;
							border-bottom-right-radius: 5px;color: #fff;border: none !important;"
								(click)="vindetailsApi();getRegdetails();">{{'GO'|translate}}</button>
						</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<span *ngIf="getvin">
							<button type="button" class="lookup-btn" (click)="openModal1(content);" style="border-radius: 5px;width: 100%;height: 100%;background-color: #003478;
								color: #fff;border: none !important;">GET VIN</button>
						</span>
					</div>

					<div style="color: red;">{{errormsg|translate}}</div>
					<div *ngIf="countrypresent" style="color: #003f87; padding-left: 18%;">
						<div><b>OR</b></div>
					</div>
					<div *ngIf="countrypresent" class="input-group " style="height: 25px">
						<input type="text" maxlength="14" class="lookup-input ng-untouched ng-pristine ng-valid"
							ng-reflect-maxlength="14" placeholder="Enter Registration number" ng-reflect-model=""
							style="font-size:14px; width: 40%;border: 1px solid #003478;" [(ngModel)]="inregnumber"
							name="inregnumber" id="inregnumber">
						<span>
							<button type="button" class="lookup-btn" style="width: 100%;
							height: 100%;background-color: #003478;border-top-right-radius: 5px;
							border-bottom-right-radius: 5px;color: #fff;border: none !important;"
								(click)="fetchVinNumber(selectVinPopup)">{{'GO'|translate}}</button>
						</span>
					</div>
					<div style="color: red;">{{errormsg_reg}}</div>
					<div style="font-size:9px; color: #003f87;">Note: Personalised plates and Ford Motor Company
						vehicles may not be listed. Registration Number entries must NOT contain spaces.</div>
				</div>
			</div>

			<div class="box0" *ngIf="vehicle">
				<div style="float: right;width: 95%;font-size: 12px;font-family: Verdana, Geneva, Tahoma, sans-serif;">
					<div class="sizeforvehiclename">
						<span
							style="font-size: 12px;color: #777777;">{{vindetail.vehicleLineDescription}},&nbsp;{{vindetail.engineDescription}},
							&nbsp;{{vindetail.paintDescription}}
						</span>
					</div>
					<div class="sizeforvehicletable">
						<table>
							<tbody style="border-bottom: 0;">
								<tr>
									<th><span>VIN Number:</span></th>
									<td><span>{{vindetail.vin}}</span></td>
								</tr>
								<tr *ngIf="noregis">
									<th><span>Registration Number:</span></th>
									<td><span>{{selectedRegistration.registration}}</span>
										<span>&nbsp;&nbsp;({{day}}.{{month}}.{{year}})</span>
									</td>
								</tr>
								<tr *ngIf="noregis">
									<th><span>First Registration Date:</span></th>
									<td><span>{{dateAsObject| date: 'dd.MM.yyyy'}}</span></td>
								</tr>
								<tr *ngIf="noregis">
									<th><span>Registration Country:</span></th>
									<td><span>{{selectedRegistration.country}}</span></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div *ngIf="setflagforlist" style="padding-left: 150px;">
						<span>
							<a (click)="listofregistration(contentRegPopup)" class="aligncenter" style="cursor: pointer;
							color: #d84d00;font-size: 11px;font-family: Verdana, Geneva, Tahoma, sans-serif;">Show registration list
								({{regdetail.length-1}}+)</a>
						</span>
					</div>
				</div><br>
			</div>

			<div class="box7">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow7=!isShow7" *ngIf="!isShow7"
						title="Click to expand"></i>
					<i *ngIf="isShow7" class="fa fa-minus-square" (click)="isShow7=!isShow7"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Primary Features</h2>
					<span>
						<table>
							<div class="primarytable">
								<tbody class="tablecontents">
									<div *ngIf="!isShow7">
										<tr>
											<th>Build Date:</th>
											<td>20.02.2017</td>
										</tr>
									</div>
									<div *ngIf="isShow7">
										<tr>
											<th>Build Date:</th>
											<td>20.02.2017</td>
										</tr>
										<tr>
											<th>Vehicle Line:</th>
											<td>Transit/Tourneo Connect 2013-
										</tr>
										<tr>
											<th>Body Style:</th>
											<td>SWB Van</td>
										</tr>
										<tr>
											<th>Version:</th>
											<td>Series 100V</td>
										</tr>
										<tr>
											<th>Engine:</th>
											<td>1.5L SOHC DI TC Diesel DV5FD A</td>
										</tr>
										<tr>
											<th>Transmission:</th>
											<td>5-Speed Manual Trans - MTX75</td>
										</tr>
										<tr>
											<th>Drive:</th>
											<td>RHD FWD</td>
										</tr>
										<tr>
											<th>Axle Ratio:</th>
											<td>3.56 Final Drive Ratio</td>
										</tr>
										<tr>
											<th>Emission:</th>
											<td>Stage VI LDT2 Emissions</td>
										</tr>
										<tr>
											<th>Air Conditioning:</th>
											<td></td>
										</tr>
										<tr>
											<th>Territory:</th>
											<td>(+)"GB"</td>
										</tr>
										<tr>
											<th>Paint:</th>
											<td>Frozen White</td>
										</tr>
										<tr>
											<th>Interior Fabric:</th>
											<td>Traxon/Max Charcoal Black</td>
										</tr>
									</div>
								</tbody>
							</div>
						</table>
					</span>
				</div>
			</div>

			<div class="box8">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow8=!isShow8" *ngIf="!isShow8"
						title="Click to expand"></i>
					<i *ngIf="isShow8" class="fa fa-minus-square" (click)="isShow8=!isShow8"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>Minor Features</h2>
					<div class="minorfeature">
						<ul>
							<li><span>&nbsp;Less Underbody Protection</span></li>
							<li><span>&nbsp;Less Roof Line Conversion</span></li>
							<li><span>&nbsp;Less Roof Wiring Hole</span></li>
							<div style="display: block;" *ngIf="isShow8">
								<li><span>&nbsp;Less Accessory USB Unit</span></li>
								<li><span>&nbsp;With Front Fascia - Level 2</span></li>
								<li><span>&nbsp;Less Front Mudflaps</span></li>
								<li><span>&nbsp;With Kerbside Side Load Doors</span></li>
								<li><span>&nbsp;With Hill Launch Assist</span></li>
								<li><span>&nbsp;With Full Partition - Steel</span></li>
								<li><span>&nbsp;With Hinged Rear Loading Doors</span></li>
								<li><span>&nbsp;With 180° Cargo Door Check Arms</span></li>
								<li><span>&nbsp;Cargo Tie Down Hooks-Inside</span></li>
								<li><span>&nbsp;With Base Payload Package</span></li>
								<li><span>&nbsp;(-) Version Packages</span></li>
								<li><span>&nbsp;Less Special Purpose Vehicle</span></li>
								<li><span>&nbsp;Valencia Plant Built</span></li>
								<li><span>&nbsp;Less Special Equipment Package</span></li>
								<li><span>&nbsp;Complete Vehicle</span></li>
								<li><span>&nbsp;Less Marketing Flex Prep Pack</span></li>
								<li><span>&nbsp;Less Special Order Paint</span></li>
								<li><span>&nbsp;Less SVO Application/Label</span></li>
								<li><span>&nbsp;Less Functional Upgrade Pack</span></li>
								<li><span>&nbsp;Marketing Level 1</span></li>
								<li><span>&nbsp;Less Dress Up RSO</span></li>
								<li><span>&nbsp;(-) SVP</span></li>
								<li><span>&nbsp;Less SIP</span></li>
								<li><span>&nbsp;Exterior Paint - Solid</span></li>
								<li><span>&nbsp;2013 Job #1 Program Control</span></li>
								<li><span>&nbsp;Less SVO Except Packs</span></li>
								<li><span>&nbsp;Less VP Application Label</span></li>
								<li><span>&nbsp;Less Water Wading Equipment</span></li>
								<li><span>&nbsp;Less Tyre Repair Service Kit</span></li>
								<li><span>&nbsp;Less Rear Package Tray</span></li>
								<li><span>&nbsp;Less Global/Auto Closing</span></li>
								<li><span>&nbsp;Power Frt Window-1 Tch Dwn-Dr Only</span></li>
								<li><span>&nbsp;Less Rear Side Window</span></li>
								<li><span>&nbsp;With Normal Tinted Glass</span></li>
								<li><span>&nbsp;Grille - Upper Bars Dk Self Colour</span></li>
								<li><span>&nbsp;Non Infra Red Refl Windscreen</span></li>
								<li><span>&nbsp;Less 2nd Row RH Side Window</span></li>
								<li><span>&nbsp;Less 2nd Row LH Side Window</span></li>
								<li><span>&nbsp;Less 3rd Row RH Side Window</span></li>
								<li><span>&nbsp;Less 3rd Row LH Side Window</span></li>
								<li><span>&nbsp;Less Rear Window</span></li>
								<li><span>&nbsp;Less Heated Windscreen</span></li>
								<li><span>&nbsp;Less Heated Rear Window</span></li>
								<li><span>&nbsp;Less Rr Seat Overhead Console</span></li>
								<li><span>&nbsp;Less Glove Box Lid</span></li>
								<li><span>&nbsp;Less Mid-Veh Overhead Console</span></li>
								<li><span>&nbsp;Base Center Console</span></li>
								<li><span>&nbsp;Cup&nbsp Holders&nbsp (2) -&nbsp Row&nbsp 1</span></li>
								<li><span>&nbsp;Int Environment Clr-Charcoal Black</span></li>
								<li><span>&nbsp;Int Feat Colour - Charcoal Black</span></li>
								<li><span>&nbsp;Less Rear Compartment Trim Panel</span></li>
								<li><span>&nbsp;Less Special Order Paint</span></li>
								<li><span>&nbsp;Less Rear Floor Mats</span></li>
								<li><span>&nbsp;Floor Cover - Rubber Ins-Partial</span></li>
								<li><span>&nbsp;With Instrument Panel Stowage Box</span></li>
								<li><span>&nbsp;Drivers Visor Mir/Flap/Tick Pocket</span></li>
								<li><span>&nbsp;Sunvisor Less Mirror - Passenger</span></li>
								<li><span>&nbsp;With Black Interior Door Handles</span></li>
								<li><span>&nbsp;With Level 1 Door Trim Panel</span></li>
								<li><span>&nbsp;Less Rear Interior Assist Handle</span></li>
								<li><span>&nbsp;Less Rear Coat Hook</span></li>
								<li><span>&nbsp;PVC Door Armrest</span></li>
								<li><span>&nbsp;Less Rr Interior Overhead Stowage</span></li>
								<li><span>&nbsp;Less Luggage Compartment Net Kit</span></li>
								<li><span>&nbsp;Less Load Retention Net</span></li>
								<li><span>&nbsp;Less Load Floor Covering</span></li>
								<li><span>&nbsp;Less First Aid Retain Straps</span></li>
								<li><span>&nbsp;Less Cargo Stowage Rack/Rail</span></li>
								<li><span>&nbsp;Interior Grab Handles - Front</span></li>
								<li><span>&nbsp;Less Interior Partition</span></li>
								<li><span>&nbsp;Less Driver Roof Storage</span></li>
								<li><span>&nbsp;With Self Colour Grille No.1</span></li>
								<li><span>&nbsp;Less Active Grilleshutter</span></li>
								<li><span>&nbsp;Less Roof Rack</span></li>
								<li><span>&nbsp;With Wide Body Moulding</span></li>
								<li><span>&nbsp;Less Rear Window Protector</span></li>
								<li><span>&nbsp;Less Rear View Mirror</span></li>
								<li><span>&nbsp;Manual Dual Mirror-Manual Fold Back</span></li>
								<li><span>&nbsp;With Self Colour Ext Mirror Finish</span></li>
								<li><span>&nbsp;Large Rear View Mirror Housing</span></li>
								<li><span>&nbsp;Less Driver Seat Back Map Pocket</span></li>
								<li><span>&nbsp;Less Passenger Seat Back Map Pocket</span></li>
								<li><span>&nbsp;Seat Pack</span></li>
								<li><span>&nbsp;Less Drivers Seat Armrest</span></li>
								<li><span>&nbsp;Less Passenger Seat Armrests</span></li>
								<li><span>&nbsp;With Front 2 Way Headrest</span></li>
								<li><span>&nbsp;With Driver Seat Recliner - Rotary</span></li>
								<li><span>&nbsp;With Passenger Seat Recliner-Rotary</span></li>
								<li><span>&nbsp;Less Tray/Table - Front Seat</span></li>
								<li><span>&nbsp;Less Rear Seat Centre Armrest</span></li>
								<li><span>&nbsp;Less Driver Seat Lumbar Support</span></li>
								<li><span>&nbsp;Less Passenger Seat Lumbar Support</span></li>
								<li><span>&nbsp;Less Under Seat Stowage - Driver</span></li>
								<li><span>&nbsp;Less Temp Control Driver Seat</span></li>
								<li><span>&nbsp;Less Temp Control Passengers Seat</span></li>
								<li><span>&nbsp;St Belt Minder-Drvr/EU Tel&amp </span></li>
								<li><span>&nbsp;Snd</span></li>
								<li><span>&nbsp;Less 2nd Row Rear Seat</span></li>
								<li><span>&nbsp;Less 3rd Row Rear Seat</span></li>
								<li><span>&nbsp;With Driver 2 Way Mnl. Seat Adjust</span></li>
								<li><span>&nbsp;With Pass 2 Way Manual Seat Adjust</span></li>
								<li><span>&nbsp;Less Trailer Towing Attachments</span></li>
								<li><span>&nbsp;Less Trailer Coupling</span></li>
								<li><span>&nbsp;Less Trailer Towing Hitch</span></li>
								<li><span>&nbsp;Less Towing Pre-Pack</span></li>
								<li><span>&nbsp;Less Trailer Sway Control (TSC)</span></li>
								<li><span>&nbsp;Less Fuel Economy Pack</span></li>
								<li><span>&nbsp;Exterior Door Handle-Self Coloured</span></li>
								<li><span>&nbsp;With Self Coloured Tailgate Handle</span></li>
								<li><span>&nbsp;Ignition Key Combination Pack 1</span></li>
								<li><span>&nbsp;With Urethane Gear Shift Knob</span></li>
								<li><span>&nbsp;With Child Proof Safety Lock</span></li>
								<li><span>&nbsp;Less Fleet Key</span></li>
								<li><span>&nbsp;Less Keyed Alike Options</span></li>
								<li><span>&nbsp;With Door Auto Relocking - Enabled</span></li>
								<li><span>&nbsp;Less Configurable Unlocking</span></li>
								<li><span>&nbsp;Frequency - 433MHZ</span></li>
								<li><span>&nbsp;With Door Dead Locks</span></li>
								<li><span>&nbsp;Less Power Lock Group</span></li>
								<li><span>&nbsp;With Door Entry Remote Control Unit</span></li>
								<li><span>&nbsp;Less Keyless Entry System</span></li>
								<li><span>&nbsp;Less Rear Window Wiper/Washer</span></li>
								<li><span>&nbsp;With Variable Intermittent Windscreen Wiper</span></li>
								<li><span>&nbsp;Less Heated Washer Jet</span></li>
								<li><span>&nbsp;Less U/Body Corrosion Protect</span></li>
								<li><span>&nbsp;Self Colour Rear Bumper End Caps</span></li>
								<li><span>&nbsp;Plastic Front Bumper</span></li>
								<li><span>&nbsp;Rear Bumper - Self Colour</span></li>
								<li><span>&nbsp;Less Front License Plate Bracket</span></li>
								<li><span>&nbsp;Less Restraint Devices</span></li>
								<li><span>&nbsp;Less Thermoplastic Kneebolster Sys</span></li>
								<li><span>&nbsp;Less Air Curtain Restraint</span></li>
								<li><span>&nbsp;Less Air Curtain Restraint RH</span></li>
								<li><span>&nbsp;Less Rear Side Air Bag Restraint</span></li>
								<li><span>&nbsp;With Inertia Front Seat Belt</span></li>
								<li><span>&nbsp;Less Rear Seat Belts</span></li>
								<li><span>&nbsp;With Driver Air Bag</span></li>
								<li><span>&nbsp;Less Passenger Air Bag</span></li>
								<li><span>&nbsp;Less Side Air Bag - Drivers Side</span></li>
								<li><span>&nbsp;Less Side Air Bag - Passenger Side</span></li>
								<li><span>&nbsp;Less Passenger Air Bag Deactivation</span></li>
								<li><span>&nbsp;Less Isofix Hard Point Attach</span></li>
								<li><span>&nbsp;With Manual Adjust Frt.S.Belt Mount</span></li>
								<li><span>&nbsp;With Steel Spare Wheel</span></li>
								<li><span>&nbsp;Less Tyre Pressure Sensors</span></li>
								<li><span>&nbsp;6.5 X 16" Steel Road Wheel</span></li>
								<li><span>&nbsp;205/60R16</span></li>
								<li><span>&nbsp;With Standard Tyre Tread - Front</span></li>
								<li><span>&nbsp;With Standard Tyre Tread - Rear</span></li>
								<li><span>&nbsp;Any Brand Tyre Vendor</span></li>
								<li><span>&nbsp;With Wheel Hub Cap</span></li>
								<li><span>&nbsp;Non Locking Lug Nuts</span></li>
								<li><span>&nbsp;Less Engine Block Heater</span></li>
								<li><span>&nbsp;Less MPH Engine Governor</span></li>
								<li><span>&nbsp;Cold Start -25 Deg C</span></li>
								<li><span>&nbsp;Standard Electric Starter Motor</span></li>
								<li><span>&nbsp;Less Remote Starter</span></li>
								<li><span>&nbsp;Stage VI LDT2 Emissions</span></li>
								<li><span>&nbsp;Solid Flywheel</span></li>
								<li><span>&nbsp;With 4 Wheel Disc-Brake</span></li>
								<li><span>&nbsp;Less Low Speed Safety System</span></li>
								<li><span>&nbsp;Brakes-HLA/ESP/TC/ABS</span></li>
								<li><span>&nbsp;Less In-Dash Internet Device-FIA</span></li>
								<li><span>&nbsp;Less Tracking System - FIA</span></li>
								<li><span>&nbsp;Front Lip Spoiler - FIA</span></li>
								<li><span>&nbsp;Less Floor Mats-FIA</span></li>
								<li><span>&nbsp;Less Remote Starter - FIA</span></li>
								<li><span>&nbsp;3.72/2.04/1.25/.919/.738/0.622</span></li>
								<li><span>&nbsp;Less Manual Shift Auto Trans</span></li>
								<li><span>&nbsp;Standard Front Seat</span></li>
								<li><span>&nbsp;Less Rear Comp Duct</span></li>
								<li><span>&nbsp;Less Air Purifier Sensor</span></li>
								<li><span>&nbsp;Less Rear Seat Climate Control</span></li>
								<li><span>&nbsp;Pollen Filter W/O Carbon Filter</span></li>
								<li><span>&nbsp;Less Heater</span></li>
								<li><span>&nbsp;Less A/C Refrigerant</span></li>
								<li><span>&nbsp;With Diesel Fuel Capability</span></li>
								<li><span>&nbsp;Less Gaseous Prep Pack</span></li>
								<li><span>&nbsp;With Fixed Foot Pedals</span></li>
								<li><span>&nbsp;With Manual Tilt/Slide Stg Column</span></li>
								<li><span>&nbsp;With Deluxe Steering Wheel</span></li>
								<li><span>&nbsp;Less Speed Control</span></li>
								<li><span>&nbsp;Less Auxiliary Heater</span></li>
								<li><span>&nbsp;With Conventional Instrumentation</span></li>
								<li><span>&nbsp;With Instrument Cluster - Rheostat</span></li>
								<li><span>&nbsp;With MPH/KMH Speedometer</span></li>
								<li><span>&nbsp;With Trip Computer</span></li>
								<li><span>&nbsp;Dual Note Electric Horn</span></li>
								<li><span>&nbsp;Less Tyre Inflation Monitor</span></li>
								<li><span>&nbsp;Less Compass Display</span></li>
								<li><span>&nbsp;Less Multi Function Display</span></li>
								<li><span>&nbsp;Less Navigation System</span></li>
								<li><span>&nbsp;Less Navigation Data</span></li>
								<li><span>&nbsp;Less Emergency Call Button</span></li>
								<li><span>&nbsp;Less Lane Departure Warning System</span></li>
								<li><span>&nbsp;Less Driver Impairment Monitor</span></li>
								<li><span>&nbsp;Less Blind Spot Information System</span></li>
								<li><span>&nbsp;Less Lane Keeping Aid</span></li>
								<li><span>&nbsp;Less Speed Sign Recognition</span></li>
								<li><span>&nbsp;Less Anti-Theft Alarm</span></li>
								<li><span>&nbsp;With Safeguard Anti-Theft Sys(Pats)</span></li>
								<li><span>&nbsp;Less Rear Parking Aid</span></li>
								<li><span>&nbsp;Less Front Parking Aid</span></li>
								<li><span>&nbsp;Standard Duty Battery</span></li>
								<li><span>&nbsp;Less Power Convertor</span></li>
								<li><span>&nbsp;With A/V Jack</span></li>
								<li><span>&nbsp;Ultra Low Audio+USB+BT+DAB</span></li>
								<li><span>&nbsp;Ice Feature Pack 2</span></li>
								<li><span>&nbsp;Less Diversity Antenna</span></li>
								<li><span>&nbsp;Less Integrated Control Panel</span></li>
								<li><span>&nbsp;With 4 Speakers - Front Only</span></li>
								<li><span>&nbsp;Microphone</span></li>
								<li><span>&nbsp;Less Sync</span></li>
								<li><span>&nbsp;With Steering Wheel Radio Controls</span></li>
								<li><span>&nbsp;Less Steering Wheel MFD Controls</span></li>
								<li><span>&nbsp;Electrical Outlet</span></li>
								<li><span>&nbsp;Less Smokers Package</span></li>
								<li><span>&nbsp;12V Aux Power Point In I/P</span></li>
								<li><span>&nbsp;Less Power Point Plug - Rear</span></li>
								<li><span>&nbsp;Less Camera</span></li>
								<li><span>&nbsp;Overhead Pod 1</span></li>
								<li><span>&nbsp;Less Auto Headlamps</span></li>
								<li><span>&nbsp;Less Fog Lamp Bezel</span></li>
								<li><span>&nbsp;With Halogen Headlamp</span></li>
								<li><span>&nbsp;With Daytime Running Lamps</span></li>
								<li><span>&nbsp;Less Headlamps - Wiper Activated</span></li>
								<li><span>&nbsp;Less Front Fog Lamps</span></li>
								<li><span>&nbsp;With Black Headlamp Bezels</span></li>
								<li><span>&nbsp;With Header Courtesy Light</span></li>
								<li><span>&nbsp;Less Rear Overhead Reading Lamps</span></li>
								<li><span>&nbsp;Less Glove Box Illumination</span></li>
								<li><span>&nbsp;With Load Compartment Lamp</span></li>
								<li><span>&nbsp;With High Mounted Stop Lamp</span></li>
								<li><span>&nbsp;With Rear Fog Lamps</span></li>
								<li><span>&nbsp;Less Headlamp Control</span></li>
								<li><span>&nbsp;Less Wiring Harness</span></li>
								<li><span>&nbsp;Less Auxiliary Fuse Panel</span></li>
							</div>
						</ul>
					</div>

					<div class="minorfeaturespan" *ngIf="!isShow8">
						<span>There are more minor features for this vehicle,
							click to expand this list.</span>
					</div>
				</div>

			</div>

			<div class="box9">
				<div class="panel-heading">
					<i class="fa fa-plus-square" (click)="isShow9=!isShow9" *ngIf="!isShow9"
						title="Click to expand"></i>
					<i *ngIf="isShow9" class="fa fa-minus-square" (click)="isShow9=!isShow9"
						title="Click to collapse"></i>
				</div>
				<div class="panel-body">
					<h2>General Warranty Information</h2>
					<span>
						<table>
							<div class="generaltable">
								<tbody class="tablecontents">
									<div *ngIf="!isShow9">
										<tr>
											<th>Start Date:</th>
											<td>23/03/2017</td>
										</tr>
									</div>
									<div *ngIf="isShow9">
										<tr>
											<th>Start Date:</th>
											<td>23/03/2017</td>
										</tr>
										<tr>
											<th>Build Date:</th>
											<td>20/02/2017</td>
										</tr>
										<tr>
											<th>Sale Mileage:</th>
											<td>Unavailable</td>
										</tr>
										<h2>Warranty Warning Messages</h2>
										<h2>Extended Coverage Information</h2>
										<p><span>No Warranty Extended Coverage information available</span></p>
									</div>
								</tbody>
							</div>
						</table>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top" style="display: block;"
		(click)="topFunction()">
	</div>

	<ng-template #content let-modal>
		<div id="full-width1" class="dialog widget widget-content corner-all front dialog-buttons draggable" style="height: auto; width:500px;display: block;top:249px;left:425px; padding: 0.2em;z-index: 100;
			font-family: Verdana, Geneva, sans-serif;font-weight: 400;font-size: 14px;line-height: 25px; border-radius: 4px;
			border: 1px solid #cecfd6;background: #fff 50% 50% repeat-x;color: #000;">
			<div class="modal-header" style="border: -1px solid white;border-radius: 5px;
			background: #003f87 ;color: #fff;font-weight: bold;height: 40px;">
				<div class="modal-title mng-qualifier-title mng-qualifier-header-popup" style="color: white;margin-top: -4px;
				margin-left: -10px;font-size: 15px;font-family: Verdana,Arial,Helvetica,Trebuchet,_sans;font-size: 14px;
					font-weight: bold;float: left;">Customer
					Consent
				</div>
				<i class="fa fa-times fa-lg mng-qualifier-close-btn" style=" margin-top: -7px;
				background: #003f87 ;" (click)="modal.close('close')" title="close" style="cursor:pointer"></i>
			</div>

			<div style="width:auto;min-height :25px;padding: .5em 1em .5em .4em; ">
				<div style="font-size: small;">
					To continue you must have the vehicle owners consent for diagnostic information to be sent back to
					Ford
					Motor Company.
				</div>
			</div>
			<div style="border-top: 1px solid #cecfd6;">
				<div style="margin-top: 10px;margin-bottom: 10px;">
					<button (click)="modal.close('close');" class="btn btn-primary shadow-none"
						style="margin-left: 160px">
						<span style="color:#fff">CONSENT DECLINED</span>
					</button>
					<button (click)="modal.close('close');openModal2(contentfdrs)" class="btn btn-primary shadow-none">
						<span style="color:#fff">CONSENT PROVIDED</span>
					</button>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #contentfdrs let-modal>
		<div id="full-width1" class="dialog widget widget-content corner-all front dialog-buttons draggable" style="height: auto; width:500px;display: block;top:249px;left:425px; padding: 0.2em; z-index: 100;
			font-family: Verdana, Geneva, sans-serif;font-weight: 400;font-size: 14px;line-height: 25px; border-radius: 4px;
			border: 1px solid #cecfd6;background: #fff 50% 50% repeat-x;color: #000;">
			<div class="modal-header" style="border: -1px solid white;border-radius: 5px;
			background: #003f87 ;color: #fff;font-weight: bold;height: 40px;">
				<i class="fa fa-times fa-lg mng-qualifier-close-btn" style=" margin-top: -7px;
				background: #003f87;cursor:pointer;margin-left: 450px;" (click)="modal.close('close')" title="close"></i>
			</div>

			<div style="width:auto;min-height :25px;padding: .5em 1em .5em .4em; ">
				<div style="font-size: small;">
					Connection is not established! Please establish connection to FDRS first.
				</div>
			</div>
			<div style="border-top: 1px solid #cecfd6;">
				<div style="margin-top: 10px;margin-bottom: 10px;">

					<button (click)="modal.close('close');openModal3()" class="btn btn-primary shadow-none"
						style="margin-left: 380px;">
						<span style="color:#fff;">CONTINUE</span>
					</button>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #contentRegPopup let-modal>
		<div class="modal-header" id="modalgreen" style="width: 130%; background-color: #003478 !important;border: 3px solid white;
		border-radius: 0px; border-top-right-radius: 3px; border-top-left-radius: 3px; cursor: move;color: #fff">
			<i class="fa fa-times fa-lg mng-qualifier-close-btn" style=" margin-top: -7px;
        background: #003f87;cursor:pointer;margin-left: 590px;" (click)="modal.close('close')" title="close"></i>
		</div>
		<div class="modal-body" id="modalblue" style="width: 130%; font-size: 14.8px;font-family: Verdana, Arial, Helvetica, Trebuchet, sans-serif;
		border: 2px solid white;border-radius: 0px;color: #286086 !important;">
			<div
				style="font-style:normal;line-height: 130%;letter-spacing: -0.03em;font-family: Verdana, Geneva, sans-serif;font-weight: 600;color: #003478;">
				Registration information for your currently selected Vehicle</div>
			<h4 style="margin-top:15px; font-size:11px;font-family: Verdana, Geneva, sans-serif;margin-bottom:5px;
  			font-weight:600;color: #003478;display: inline-block;">First Registration Date:</h4>
			<table cellspacing="0" cellpadding="10">
				<thead class="table__headings" style="background-color: #003478 !important;">
					<tr>
						<th>Registration Number:</th>
						<th>Registration Date:</th>
						<th>Registration Country:</th>
						<th>Modified Date:</th>
					</tr>
				</thead>
				<tbody class="table__contents">
					<tr>
						<td>{{regilast}}</td>
						<td *ngIf="datelast">{{datelast.split("T",1)| date: 'dd.MM.yyyy'}}</td>
						<td *ngIf="!datelast">-</td>
						<td>{{countrylast}}</td>
						<td *ngIf="createtimelast">{{createtimelast.split("T",1)| date: 'dd.MM.yyyy'}}</td>
						<td *ngIf="!createtimelast">-</td>
					</tr>
				</tbody>
			</table>
			<h4 style="margin-top:15px; font-size:11px;font-family: Verdana, Geneva, sans-serif;margin-bottom:5px;
            font-weight:600;color: #003478;display: inline-block;">Historic Registration Date:</h4>
			<table cellspacing="0" cellpadding="10">
				<thead class="table__headings" style="background-color: #003478 !important;">
					<tr>
						<th>Registration Number:</th>
						<th>Registration Date:</th>
						<th>Registration Country:</th>
						<th>Modified Date:</th>
					</tr>
				</thead>
				<tbody class="table__contents">
					<tr *ngFor="let i of regdetail;">
						<td>{{i.registration}}</td>
						<td *ngIf="i.dateAsObject">{{i.dateAsObject.split("T",1)| date: 'dd.MM.yyyy'}}</td>
						<td *ngIf="!i.dateAsObject">-</td>
						<td>{{i.country}}</td>
						<td *ngIf="i.createTime">{{i.createTime.split("T",1)| date: 'dd.MM.yyyy'}}</td>
						<td *ngIf="!i.createTime">-</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="modal-footer" id="modalblue" style="border-top: 1px solid #cecfd6;">
			<button type="button" class="btn btn-primary mr-3 shadow-none" (click)="modal.close('close')">{{'CLOSE'|translate}}</button>
		</div>

	</ng-template>

	<ng-template #selectVinPopup let-c="close" let-d="dismiss">
		<div class="selectVinPopup" style="border: 5px solid white">
			<div style="font-size: 13px;height: 39px;line-height: 28px;padding: 5px 13px 13px 5px;
            background-color: #003478;color: white;font-family: Verdana,Arial,Helvetica,Trebuchet,_sans;
            border: 1px solid #cecfd6;font-weight: 500;border-radius: 4px;">
				<div class="padding-popup-header" style="float: left;width: 97%;padding-left: 10px;font-size: 15px;">
					Registration Search Results</div>
				<div class="cross-button" title="close" style="cursor:pointer;color: white;
                background-color: #003478;float: right;width: 3%;text-align: center;"><i class="fa fa-times"
						aria-hidden="true" (click)="d('Cross click')"></i></div>
			</div>
			<div class="popup-body" style="font-family: Verdana, Geneva, sans-serif;font-size: 14px;padding:13px;">
				<div class="popup-text1" style="font-family: Verdana, Geneva, sans-serif;
                font-size: 12px;padding-top: 10px;margin-bottom: 1%;">More than one VIN numbers were found for the
					registration number you entered, we are displaying the top five VIN matches:</div>
				<ul class="text-font" style="font-size: 12px;">
					<li *ngFor="let vehicle of availableVins"><a href="#"
							(click)="c('Cross click');passSelectedVin(vehicle.vin);$event.preventDefault()">{{vehicle.vin}}</a>
						{{vehicle.vehicleLineDescription}}, {{vehicle.engineDescription}}, {{vehicle.paintDescription}}
					</li>
				</ul>
			</div>
			<hr class="hr-line" style="margin-bottom: 1% !important;">
			<div>
				<div class="col-md-12">
					<button (click)="c('Cross click')" class="btn btn-primary shadow-none" style="float: right;">
						<span style="color:#fff">{{'CLOSE'|translate}}</span>
					</button>
				</div>
			</div>
		</div>
	</ng-template>

</div>